import { useMemo, useCallback, useEffect } from 'react'
import _get from 'lodash/get'
import _sortBy from 'lodash/sortBy'
import { useSettings } from '~/redux/hooks/settings'

import { useSyncedStores } from '~/redux/hooks/store'
import { showDialog } from '~/components/common/Dialog'
import { dialogParams } from '~/components/common/Dialog/CustomDialog'
import { useAccessibleLocations, useUser } from '~/redux/hooks/user'

const useNotification = (storeId: string, enabled = true) => {
  const {
    actions,
    notificationSettings: { data: notificationSetting, loading },
  } = useSettings()
  const authStores = useSyncedStores()

  const {
    user: { stores },
  } = useUser()
  const currentStore = stores?.find((store) => store.store_id === storeId)
  const accessibleLocations = useAccessibleLocations(storeId)
  const linkedWarehouses = useMemo(() => {
    const whs = _get(currentStore, 'linked_warehouses', [])
    if (accessibleLocations.length) {
      return whs.filter((w) => accessibleLocations.includes(w.location_id))
    }
    return whs
  }, [currentStore, accessibleLocations])

  const storeIds = useMemo(
    () => authStores.map((store) => store.storeId),
    [authStores],
  )

  useEffect(() => {
    actions.getNotificationSettings([storeId])
  }, [storeId])

  const data = useMemo(
    () => _get(notificationSetting, `${storeId}`, []),
    [notificationSetting, storeId],
  )

  const onSaveSetting = useCallback(
    (config) => {
      return new Promise((resolve, reject) => {
        const params = {
          store_ids: storeIds.map((s) => ({
            store_id: storeId,
            ...config,
          })),
        }

        actions.updateNotificationSettings(params, {
          onSuccess: (response) => {
            // showDialog({
            //   ...dialogParams.changesSaved,
            // })
            resolve(response)
          },
          onError: (e) => {
            showDialog({
              ...dialogParams.error,
              ...{
                description: e,
                icon: 'warn',
                okText: 'OK',
              },
            })
            reject(e)
          },
        })
      })
    },
    [actions, storeIds, storeId],
  )

  return {
    loading,
    data,
    actions,
    storeId,
    onSaveSetting,
    linkedWarehouses,
  }
}

export default useNotification
